// Action types for saving data
export const GET_CHANNEL_DATA_REQUEST = 'GET_CHANNEL_DATA_REQUEST';
export const GET_CHANNEL_DATA_SUCCESS = 'GET_CHANNEL_DATA_SUCCESS';
export const GET_CHANNEL_DATA_FAILURE = 'GET_CHANNEL_DATA_FAILURE';
export const GET_CHANNEL_DATA_RESET = 'GET_CHANNEL_DATA_RESET';
// Save data actions
export const getChannelDataRequest = (payload) => ({
    type: GET_CHANNEL_DATA_REQUEST,
    payload
});
export const getChannelDataSuccess = (payload) => ({
    type: GET_CHANNEL_DATA_SUCCESS,
    payload,
});
export const getChannelDataFailure = (error) => ({
    type: GET_CHANNEL_DATA_FAILURE,
    payload: error,
});
export const getChannelDataReset = () => ({
    type: GET_CHANNEL_DATA_RESET,
});
